import React from 'react'
import PedidosYaStyle from '../../../../../assets/css/components/admin/plugins/PedidosYaStyle'

export default function Navbar(props) {
    const {setCurrentStep, currentStep} = props;

    const changeStep = (v) => {
        setCurrentStep(v)
    }
    return (
        <PedidosYaStyle.ContNavbar>
            <PedidosYaStyle.MenuOptions>
                <PedidosYaStyle.OptionMenu active={currentStep === 1} onClick={() => changeStep(1)}>
                    Crear usuario FTP
                </PedidosYaStyle.OptionMenu>
                <PedidosYaStyle.OptionMenu active={currentStep === 2 || currentStep === 3} onClick={() => changeStep(2)}>
                    Sucursales
                </PedidosYaStyle.OptionMenu>
                <PedidosYaStyle.OptionMenu active={currentStep === 4 || currentStep === 5} onClick={() => changeStep(4)}>
                    Listado de Secciones
                </PedidosYaStyle.OptionMenu>
                <PedidosYaStyle.OptionMenu active={currentStep === 6} onClick={() => changeStep(6)}>
                    Listado de Restaurantes
                </PedidosYaStyle.OptionMenu>
            </PedidosYaStyle.MenuOptions>
        </PedidosYaStyle.ContNavbar>
    )
}
